import * as React from "react";

function SvgConvertFlow(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 456 426"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M229.676 119.374c63.6-1.5 106.5.4 135.3 6 24.2 4.7 45.3 13.1 57.5 22.9 5.8 4.7 6.1 4.8 6.7 2.8 1.1-4.3.6-27.3-.9-33.9-5.1-24.3-20.8-43.4-46.2-56.2-37.9-19-83.9-26.2-150.3-23.3-34 1.5-89.2 1.4-106-.2-51.5-4.7-88.8-14.9-112.6-30.7-4.9-3.2-9.4-6.2-10-6.6-.7-.5-1.4.1-1.8 1.5-1.4 4.8-1.9 27.4-.7 34.2 4.6 27.5 19.2 46.7 45.7 60.2 37.8 19.4 85.9 25.5 183.3 23.3zM334.276 252.874c40.8 3.9 68.4 12.2 86.9 26.2 6 4.5 7.2 5 7.9 3.7.5-.9.7-8.7.5-17.3-.6-17.7-2.1-24-9-37.4-15.3-29.5-56.3-49.6-117.3-57.4-12.3-1.6-21-1.8-71.5-1.6-76.5.4-97.8-1-117.7-7.8-4.8-1.6-8.8-2.9-9-2.9-.2 0-.1 1.9.3 4.2 5.5 39.6 28.6 65.6 69.6 78.7 23.5 7.5 29.5 8.1 89.8 9.1 34.7.5 58.3 1.4 69.5 2.5zM408.876 337.374c-10-9.9-18.8-15.2-35.9-21.8-22.3-8.5-42.4-11.7-81.7-13.2-25.2-1-34.2-1.9-41.5-4-1.9-.5-3.8-1-4.2-1-.5 0-.8 3.1-.8 6.8 0 20.3 12.3 42.8 30.4 55.6 16.7 11.9 35 17.5 66.1 20.1 9.4.9 20.8 2.2 25.5 3.1 22.2 4 42.6 12.6 56.5 24l5.4 4.4.7-3.8c.4-2 .8-8.9.8-15.2 0-14.7-2.2-24.7-8.1-37-3.8-8-5.9-10.7-13.2-18z"
        fill="#068FF8"
      />
    </svg>
  );
}

export default React.forwardRef(SvgConvertFlow);
